import React from "react";
import { View, Text, StyleSheet, Pressable } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { useTheme } from "../../../context/ThemeContext";
import { useMobile } from "../../../hooks/useMobile";
import routes from "../../../navigation/routes";
import { Reveal, FONT_DISPLAY } from "./_shared";

export default function NtVoxcraftCtaStrip() {
  const { theme } = useTheme();
  const nav = useNavigation();
  const isMobile = useMobile();

  return (
    <View style={[styles.section, { paddingVertical: isMobile ? 80 : 120 }]}>
      <Reveal style={[styles.card, { borderColor: theme.borderSoft, backgroundColor: theme.surface }]}>
        <Text style={[styles.title, { color: theme.text }]}>Stop ordering hardware.{"\n"}Start dialing.</Text>
        <Text style={[styles.sub, { color: theme.textDim }]}>
          Your AI-generated starter setup is waiting. Answer a few questions and your PBX is live.
        </Text>
        <View style={styles.ctas}>
          <Pressable onPress={() => nav.navigate(routes.onboarding)} style={({ pressed }) => [styles.btn, styles.btnPrimary, pressed && styles.btnPressed]}>
            <Text style={styles.btnPrimaryText}>Get started</Text>
          </Pressable>
          <Pressable onPress={() => nav.navigate(routes.learnmore)} style={({ pressed }) => [styles.btn, { borderColor: theme.borderSoft, backgroundColor: theme.bg2 }, pressed && styles.btnPressed]}>
            <Text style={[styles.btnGhostText, { color: theme.text }]}>Learn more →</Text>
          </Pressable>
        </View>
      </Reveal>
    </View>
  );
}

const styles = StyleSheet.create({
  section: { paddingHorizontal: 28, alignItems: "center" },
  card: { width: "100%", maxWidth: 880, padding: 56, borderRadius: 16, borderWidth: 1, alignItems: "center" },
  title: { fontFamily: FONT_DISPLAY, fontSize: 36, fontWeight: "800", letterSpacing: -1, lineHeight: 40, textAlign: "center", marginBottom: 16 },
  sub: { fontSize: 16, lineHeight: 24, textAlign: "center", maxWidth: 540, marginBottom: 28 },
  ctas: { flexDirection: "row", flexWrap: "wrap", justifyContent: "center" },
  btn: { paddingHorizontal: 22, paddingVertical: 14, borderRadius: 10, borderWidth: 1, alignItems: "center", justifyContent: "center", marginRight: 12, marginBottom: 8 },
  btnPrimary: { backgroundColor: "#2570BD", borderColor: "#2570BD" },
  btnPrimaryText: { color: "#fff", fontSize: 14, fontWeight: "600" },
  btnGhostText: { fontSize: 14, fontWeight: "600" },
  btnPressed: { opacity: 0.85, transform: [{ translateY: -1 }] },
});
